import React, { useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const pages = [{
  src: 'https://cdn.magicpatterns.com/uploads/wHr2557T4AcWEWCKMBsVLA/Captura-de-pantalla-2026-09-07-a-la_s_-7.56.16_p._m..webp',
  label: 'Exercise Library — Lunge Family'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/2gHTyuEqiGXFCUUQEGgWXE/Captura-de-pantalla-2026-09-07-a-la_s_-7.51.22_p._m..png',
  label: 'Squat — Advanced & Integrated'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/cAZSpjBXhrnVNTDPQhTk7y/Captura-de-pantalla-2026-09-07-a-la_s_-7.52.54_p._m..png',
  label: 'Horizontal Push — Push-Up Variations'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/byc6XdsCbBwFgBq8o6LXi3/Captura-de-pantalla-2026-09-07-a-la_s_-7.55.30_p._m..webp',
  label: 'Squat — Dumbbell Variations'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/xmxErH4yNTPBLRij569WNy/Captura-de-pantalla-2026-09-07-a-la_s_-7.53.16_p._m..png',
  label: 'Vertical Push — Kettlebell & Angled Press'
}];
export function LookInside() {
  const [index, setIndex] = useState(0);
  const goTo = (next: number) => {
    setIndex((next + pages.length) % pages.length);
  };
  const scrollToPricing = () => {
    const el = document.getElementById('pricing');
    if (el) el.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-8 sm:py-10 px-4 bg-brand-cream border-y border-brand-gold/30" data-id="element-125" data-mp="ezoa50gv727g">
      <div className="max-w-4xl mx-auto" data-id="element-126" data-mp="3nhu5hjlnq7xc">
        <div className="text-center mb-5" data-id="element-127" data-mp="3iir9sprkhe21">
          <p className="text-sm font-bold text-brand-gold uppercase tracking-wide mb-2" data-id="element-128" data-mp="3ik2fww8hixwb">
            👀 LOOK INSIDE FUNCTIONAL PRO™
          </p>
          <h2 className="text-2xl sm:text-3xl font-serif font-bold text-brand-graphite" data-id="element-129" data-mp="3sgxdncwxou9j">
            DON'T JUST READ WHAT'S INCLUDED. SEE WHAT YOU'LL ACTUALLY USE.
          </h2>
        </div>

        <div className="relative" data-id="element-130" data-mp="2zrztt5d2qpeo">
          <button type="button" onClick={scrollToPricing} aria-label={`${pages[index].label} — go to the offer`} className="block w-full bg-white border-2 border-brand-petrol/20 rounded-xl overflow-hidden shadow-lg" data-id="element-131" data-mp="2zqyjx47so8yj">
            <img src={pages[index].src} alt={pages[index].label} className="w-full h-auto object-contain max-h-[70vh] mx-auto" data-id="element-132" data-mp="1dewqghibhrjk" />
          </button>

          <button type="button" onClick={() => goTo(index - 1)} aria-label="Previous page" className="absolute left-2 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-brand-petrol text-white border-2 border-white shadow-lg flex items-center justify-center hover:bg-brand-graphite transition-colors" data-id="element-133" data-mp="kqiu066vn3a4">
            <ChevronLeftIcon className="w-5 h-5" data-id="element-134" data-mp="ynny40n15s2q" />
          </button>

          <button type="button" onClick={() => goTo(index + 1)} aria-label="Next page" className="absolute right-2 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-brand-petrol text-white border-2 border-white shadow-lg flex items-center justify-center hover:bg-brand-graphite transition-colors" data-id="element-135" data-mp="2551b8h9zoglb">
            <ChevronRightIcon className="w-5 h-5" data-id="element-136" data-mp="2aisz7u7vmypg" />
          </button>
        </div>

        <p className="text-center text-sm font-semibold text-brand-petrol mt-3" data-id="element-137" data-mp="26hfrtfp4yngf">
          {pages[index].label}
        </p>

        <div className="flex justify-center gap-2 mt-3" data-id="element-138" data-mp="21iw5vfajlbo2">
          {pages.map((page, i) => <button key={page.src} type="button" onClick={() => goTo(i)} aria-label={`Show ${page.label}`} aria-current={i === index} className={`h-2.5 rounded-full transition-all duration-200 ${i === index ? 'w-6 bg-brand-petrol' : 'w-2.5 bg-brand-petrol/25 hover:bg-brand-petrol/50'}`} data-id="element-139" data-mp="1wiqiibbb2bbs" data-mpi={i} />)}
        </div>

        <div className="flex gap-2 justify-center mt-4 overflow-x-auto pb-1" data-id="element-140" data-mp="3ozt3o6y9u2ld">
          {pages.map((page, i) => <button key={`thumb-${page.src}`} type="button" onClick={() => goTo(i)} aria-label={`Show ${page.label}`} className={`shrink-0 w-14 h-16 rounded-md overflow-hidden border-2 transition-colors ${i === index ? 'border-brand-gold' : 'border-brand-petrol/20 opacity-70 hover:opacity-100'}`} data-id="element-141" data-mp="3tzfigktqzqwa" data-mpi={i}>
              <img src={page.src} alt="" className="w-full h-full object-cover object-top" data-id="element-142" data-mp="3b1corsq995s5" />
            </button>)}
        </div>
      </div>
    </section>;
}